import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from '@angular/common';

@Pipe({
  name: 'decimalHochkomma'
})
export class DecimalHochkommaPipe implements PipeTransform {
  constructor(private number: DecimalPipe) {}

  /**
   * 145781 -> 145'781
   * @param {number} value
   * @param args
   * @returns {string}
   */
  transform(value: number, args?: any): string {
    return this.number.transform(value, '1.0-3', 'de-CH');
  }
}
